import { Outlet } from 'react-router-dom'
import type { RouteRecord } from 'vite-react-ssg'
import { getAllSlugs, getAllTagsGlobal, slugifyTag } from './lib/blog'
import AGB from './pages/AGB'
import BlogIndex from './pages/BlogIndex'
import BlogPost from './pages/BlogPost'
import BlogTag from './pages/BlogTag'
import Datenschutz from './pages/Datenschutz'
import Impressum from './pages/Impressum'
import LandingPage from './pages/LandingPage'
import Support from './pages/Support'
import CoParentingSeoPage from './pages/seo/CoParentingSeoPage'
import CoParentingSeoPageEn from './pages/seo/CoParentingSeoPageEn'
import CouplesSeoPage from './pages/seo/CouplesSeoPage'
import FamilienbudgetSeoPage from './pages/seo/FamilienbudgetSeoPage'
import FamilyBudgetSeoPage from './pages/seo/FamilyBudgetSeoPage'
import PaareSeoPage from './pages/seo/PaareSeoPage'

// Legacy URLs `/privacy-policy` and `/terms` are redirected server-side
// via public/.htaccess (301 → /datenschutz and /agb respectively).

function RootLayout() {
  return <Outlet />
}

export const routes: RouteRecord[] = [
  {
    path: '/',
    element: <RootLayout />,
    entry: 'src/App.tsx',
    children: [
      {
        index: true,
        element: <LandingPage />,
        entry: 'src/pages/LandingPage.tsx',
      },
      {
        path: 'impressum',
        element: <Impressum />,
        entry: 'src/pages/Impressum.tsx',
      },
      {
        path: 'datenschutz',
        element: <Datenschutz />,
        entry: 'src/pages/Datenschutz.tsx',
      },
      {
        path: 'agb',
        element: <AGB />,
        entry: 'src/pages/AGB.tsx',
      },
      {
        path: 'support',
        element: <Support />,
        entry: 'src/pages/Support.tsx',
      },
      {
        path: 'blog',
        element: <BlogIndex />,
        entry: 'src/pages/BlogIndex.tsx',
      },
      {
        path: 'blog/:slug',
        element: <BlogPost />,
        entry: 'src/pages/BlogPost.tsx',
        getStaticPaths: () => getAllSlugs().map((slug) => `blog/${slug}`),
      },
      {
        path: 'blog/tag/:tag',
        element: <BlogTag />,
        entry: 'src/pages/BlogTag.tsx',
        getStaticPaths: () =>
          Array.from(new Set(getAllTagsGlobal().map((tag) => slugifyTag(tag)))).map(
            (slug) => `blog/tag/${slug}`,
          ),
      },
      {
        path: 'ausgaben-teilen-paare',
        element: <PaareSeoPage />,
        entry: 'src/pages/seo/PaareSeoPage.tsx',
      },
      {
        path: 'expense-sharing-couples',
        element: <CouplesSeoPage />,
        entry: 'src/pages/seo/CouplesSeoPage.tsx',
      },
      {
        path: 'co-parenting-ausgaben-teilen',
        element: <CoParentingSeoPage />,
        entry: 'src/pages/seo/CoParentingSeoPage.tsx',
      },
      {
        path: 'co-parenting-expense-sharing',
        element: <CoParentingSeoPageEn />,
        entry: 'src/pages/seo/CoParentingSeoPageEn.tsx',
      },
      {
        path: 'familienbudget-app',
        element: <FamilienbudgetSeoPage />,
        entry: 'src/pages/seo/FamilienbudgetSeoPage.tsx',
      },
      {
        path: 'family-budget-app',
        element: <FamilyBudgetSeoPage />,
        entry: 'src/pages/seo/FamilyBudgetSeoPage.tsx',
      },
    ],
  },
]
